import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDevices } from '../traccar';
import VehicleHistory from '../VehicleHistory';

// Top-nav Trip History: loads the customer's cars and opens the full-screen
// trip history for the first one, with the in-screen car switcher to change it.
export default function TripHistoryPage() {
  const nav = useNavigate();
  const [devices, setDevices] = useState([]);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    getDevices().then((d) => { setDevices(d || []); setReady(true); }).catch(() => setReady(true));
  }, []);
  const back = () => nav('/car?tagalong');
  if (!ready) return <div style={{ padding: '48px 20px', textAlign: 'center', color: '#94a3b8' }}>Loading trip history…</div>;
  if (!devices.length) return <div style={{ padding: '48px 20px', textAlign: 'center', color: '#94a3b8' }}>No vehicles on your account yet.</div>;
  return <VehicleHistory device={devices[0]} devices={devices} onClose={back} asPage />;
}
